
<template lang="pug">
  div
    form(@submit.prevent="submit" v-disable-all="!loaded")
      .row.message( aria-live="polite" v-if="saved" ) Your account has been updated!
      .row.two-cols
        div(v-bind:class="v$.first_name.$error ? 'has_error' : ''")
          label(for="user_first_name") First Name (Required)
          input(type="text" name="first_name" aria-describedby="user_first_name" v-model="first_name")
          p.error(id="user_first_name"  role="status" v-for="error of v$.first_name.$errors" :key="error.$uid" v-html="error.$message")
        div(v-bind:class="v$.last_name.$error ? 'has_error' : ''")
          label(for="user_last_name") Last Name (Required)
          input(type="text" name="last_name" id="user_last_name" v-model="last_name")
          p.error(aria-describedby="user_last_name" role="status" v-for="error of v$.last_name.$errors" :key="error.$uid" v-html="error.$message")
      .row(v-bind:class="v$.email.$error ? 'has_error' : ''")
        label(for="user_email") Email
        input(type="email" name="email" aria-describedby="user_email" v-model="email" @change="v$.email.$touch" readonly)
        p.error(id="user_email" role="status" v-for="error of v$.email.$errors" :key="error.$uid" v-html="error.$message")
      //.row.two-cols
        div(v-bind:class="v$.birth_month.$error ? 'has_error' : ''")
          label(for="user_birth_month") Birth Month (MM)
          input(type="number" maxlength="2" name="birth_month" id="user_birth_month" v-model="birth_month")
          p.error(role="status" v-for="error of v$.birth_month.$errors" :key="error.$uid" v-html="error.$message")
        div(v-bind:class="v$.birth_year.$error ? 'has_error' : ''")
          label(for="user_birth_year") Birth Year (YYYY)
          input(type="number" name="birth_year" id="user_birth_year" v-model="birth_year")
          p.error(role="status" v-for="error of v$.birth_year.$errors" :key="error.$uid" v-html="error.$message")
      .row(v-bind:class="v$.postal_code.$error ? 'has_error' : ''")
        label(for="user_postal_code") Zip Code
        input(type="text" name="postal_code" aria-describedby="user_postal_code" v-model="postal_code")
        p.error(id="user_postal_code" role="status" v-for="error of v$.postal_code.$errors" :key="error.$uid" v-html="error.$message")
      .row
        label(for="user_question1") What's your dietary preference?
        select(name="question1" id="user_question1" data-question="DietPreference" data-question-id="8270a1d0-46c1-4b88-a360-bffbafd337da")
          option(disabled selected) Select Answer
          <option value="Searching for KETO Snacks">Searching for KETO Snacks</option>
          <option value="Low Carb/Low Sugar Solutions">Low Carb/Low Sugar Solutions</option>
          <option value="Protein Seeker">Protein Seeker</option>
      .row(v-bind:class="v$.old_password.$error ? 'has_error' : ''")
        label(for="user_old_password") Current Password (Required)
        input(type="password" aria-describedby="user_old_password" name="old_password" v-model="old_password")
        p.error(id="user_old_password" role="status" v-for="error of v$.old_password.$errors" :key="error.$uid" v-html="error.$message")
      .row(v-bind:class="v$.password.$error ? 'has_error' : ''")
        label(for="user_password") New Password (Optional)
        input(type="password" aria-describedby="user_password" name="password" v-model="password")
        p.error(id="user_password" role="status" v-for="error of v$.password.$errors" :key="error.$uid" v-html="error.$message")
      .row(v-bind:class="v$.password_confirmation.$error ? 'has_error' : ''")
        label(for="user_password_confirmation") Confirm Password (Optional)
        input(type="password" aria-describedby="user_password_confirmation" name="password_confirmation" v-model="password_confirmation")
        p.error(id="user_password_confirmation" role="status" v-for="error of v$.password_confirmation.$errors" :key="error.$uid" v-html="error.$message")
      .row
        input.btn.btn--primary(type="submit" value="Submit")
</template>

<script>
  const Rule2Property = {
    'first name': 'first_name',
    'last name': 'last_name',
    'old_password': 'old_password',
    'zip.code.rule': 'postal_code',
    'unique.email.rule': 'email',
    'password.strength.rule': 'password'
  };

  import { email, sameAs, helpers } from '@vuelidate/validators';
  import { useVuelidate } from '@vuelidate/core';
  import { mandatory, minSize, maxSize } from '../../helpers/validators.js';

  export default {
    name: 'Profile',

    components: {
    },

    props: {
    },

    setup() {
      return {
        v$: useVuelidate(null, null, {
          $lazy: true,
          $autoDirty: true
        })
      }
    },

    mounted() {
      this.loaded = false;
      fetch(
        this.$parent.url + 'customer', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.$parent.getSession())
        }
      ).then(r => {
        if (r.status == 400)
          this.$parent.logout(true);
        return r;
      }).then(response => response.json()).then(data => {
        if (data.error == 'invalid_grant') {
          this.$parent.logout(true);
          return;
        }
        if (data.cdata)
          this.$parent.setSession(data);

        this.first_name = data.FirstName;
        this.last_name = data.LastName;
        this.email = data.Email;
        if (data.BirthDate) {
          this.birth_month = data.BirthDate.substr(5, 2);
          this.birth_year = data.BirthDate.substr(0, 4);
        }
        this.postal_code = data.PostalCode;
        this.loaded = true;

        if (data.Questions) {
          for (const v of data.Questions) {
            const d = document.querySelector(`select[data-question-id="${v.QuestionId}"] option[value="${v.Answer.AnswerText}"]`);
            if (d)
              d.selected = true;
          }
        }
      })/*.catch(() => {
      })*/;
    },

    data() {
      return {
        loaded: false,
        saved: false,
        first_name: '',
        last_name: '',
        email: '',
        birth_month: '',
        birth_year: '',
        postal_code: '',
        old_password: '',
        password: '',
        password_confirmation: '',
        vuelidateExternalResults: {
          first_name: [],
          last_name: [],
          birth_month: [],
          birth_year: [],
          postal_code: [],
          email: [],
          old_password: [],
          password: [],
          password_confirmation: []
        }
      }
    },

    validations () {
      return {
        first_name: { required: mandatory('First name') },
        last_name: { required: mandatory('Last name') },
        email: { required: mandatory('Email'), email },
        postal_code: { minLength: minSize('Zip code', 5), maxLength: maxSize('zip code', 5) },
        old_password: { required: mandatory('Current password'), minLength: minSize('Current password', 8) },
        password: { minLength: minSize('Password', 8), maxLength: maxSize('Password', 128) },
        password_confirmation: { sameAs: helpers.withMessage(
          'Password are not matching',
          sameAs(this.password)
        ) }
      }
    },

    methods: {
      async submit() {
        this.saved = false;
        for (const key in this.vuelidateExternalResults)
          this.vuelidateExternalResults[key] = [];

        const result = await this.v$.$validate();
        if (!result) {
          // focus on the first invalid field
          const firstErrorProperty = this.v$.$errors[0].$property;
          this.$el.querySelector(`[name="${firstErrorProperty}"]`).focus();
          return;
        }

        const questions = [];
        document.querySelectorAll('select[data-question]').forEach((v) => {
          if (/^[0-9A-F\-]+$/.test(v.value) && v.value.length == 36)
            questions.push({ "QuestionCode": v.getAttribute('data-question'), "Answer": { "AnswerId": v.value } });
          else
            questions.push({ "QuestionCode": v.getAttribute('data-question'), "Answer": { "AnswerText": v.value } });
        });

        const data = {
          email: this.email,
          first_name: this.first_name,
          last_name: this.last_name,
          // birth_date: `${this.birth_year}-${this.birth_month}-01`,
          postal_code: this.postal_code,
          old_password: this.old_password,
          password: this.password,
          questions: questions
        };

        // 'email', 'birth_date', 'password', 'first_name', 'last_name', 'postal_code', 'source_code', 'questions'
        this.loaded = false;
        fetch(
          this.$parent.url + 'update', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(Object.assign(data, this.$parent.getSession()))
          }
        ).then(response => response.json()).then(data => {
          if (data.cdata)
            this.$parent.setSession(data);

          this.loaded = true;
          if (data.Errors) {
            const errors = {};
            for (const v of data.Errors) {
              const p = Rule2Property[v.RuleId] || Rule2Property[v.FieldName];
              if (!p)
                continue;
              if (errors[p])
                errors[p].push(v.Message);
              else
                errors[p] = [ v.Message ];
            }
            Object.assign(this.vuelidateExternalResults, errors);
            return;
          }

          this.saved = true;
        }).catch(() => {
        });
      }
    }
  }
</script>

<style scoped lang="scss">
</style>
